module.exports = __webpack_public_path__ + "img/close-circle.63326345.svg";